<template>
    <v-container fluid grid-list-md>
        <v-layout>
            <v-flex>
                <h1 class="display-3">Cobranzas</h1>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex xs12 md3>
                <empresa-select v-model="empresa_id" @actualiza="consulta()"></empresa-select>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <v-card>
                    <v-card-title>
                        <v-menu :close-on-content-click="false" :nudge-width="200" offset-x>
                            <v-btn label="opciones" color="orange" dark slot="activator">
                                Opciones
                                <v-icon right>build</v-icon>
                            </v-btn>
                            <v-card>
                                <v-list>
                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-switch v-model="soloSaldo" @change="consulta()"></v-switch>
                                        </v-list-tile-action>
                                        <v-list-tile-content>
                                            <v-list-tile-title>Sólo mostrar lo que posee saldo
                                                <v-icon small color="green" @click="guardaPref('soloSaldo',soloSaldo)">save</v-icon>
                                            </v-list-tile-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                </v-list>
                            </v-card>
                        </v-menu>
                        <v-btn color="primary" dark @click.native="filterModal = true">
                            Filtros
                            <v-icon right>filter_list</v-icon>
                        </v-btn>
                        <v-text-field
                                label="Búsqueda"
                                prepend-icon="search"
                                v-model="search"
                                v-debounce:300ms="consulta">
                            <v-icon @click="searchFilterModal = true" slot="append-outer">filter_list</v-icon>
                        </v-text-field>
                    </v-card-title>
                    <v-data-table
                            :pagination.sync="pag"
                            :total-items="totalItems"
                            :loading="loading"
                            :rows-per-page-items="rows"
                            rows-per-page-text="Filas por pagina"
                            no-data-text="No hay datos"
                            disable-initial-sort
                            :headers="headers"
                            :items="items"
                            class="tabla-compacta-col"
                            expand
                    >
                        <template slot="items" slot-scope="props">
                            <td class="text-xs-center no-wrap">
                                <v-icon small v-if="props.item.E1_SALDO == 0" color="green">check_circle_outline</v-icon>
                                <v-tooltip top color="red" v-else>
                                    <v-icon small color="red" slot="activator">error_outline</v-icon>
                                    <span>Saldo: {{ props.item.E1_SALDO | moneda(props.item.F2_MOEDA) }}</span>
                                </v-tooltip>
                                <v-tooltip top v-if="props.item.OBS.length > 0">
                                    <v-icon color="blue" small slot="activator" @click="obsShow(props.item)">far fa-comment</v-icon>
                                    <span>Posee {{ props.item.OBS.length }} observaciones</span>
                                </v-tooltip>

                            </td>
                            <td class="text-xs-center">{{ props.item.F2_EMISSAO | fecha }}</td>
                            <td class="text-xs-center">
                                <v-tooltip top>
                                    <span slot="activator">{{ props.item.F2_ESPECIE}}</span>
                                    <span>{{ props.item.X5_DESCSPA }}</span>
                                </v-tooltip>
                            </td>
                            <td class="text-xs-center">{{ props.item.F2_SERIE }}</td>
                            <td class="text-xs-center">{{ props.item.F2_DOC }}</td>
                            <td class="text-xs-left">({{ props.item.F2_CLIENTE }}) {{ props.item.A1_NOME }}</td>
                            <td class="text-xs-center">{{ props.item.A1_CGC }}</td>
                            <td class="text-xs-center">{{ props.item.F2_USREQVE }}</td>
                            <td class="text-xs-center">{{ props.item.A3_NOME }}</td>
                            <td class="text-xs-right no-wrap">{{ props.item.F2_VALMERC | moneda(props.item.F2_MOEDA)}}</td>
                            <td class="text-xs-right no-wrap">{{ props.item.F2_VALFAT | moneda(props.item.F2_MOEDA) }}</td>
                            <td class="text-xs-right no-wrap">{{ props.item.E1_SALDO | moneda(props.item.F2_MOEDA) }}</td>
                            <td class="text-xs-right no-wrap"
                                :class="{
                                'red--text': props.item.COBRADO >= 0  && props.item.COBRADO < 40,
                                'yellow--text': props.item.COBRADO >= 40 && props.item.COBRADO <= 60,
                                'green--text':props.item.COBRADO > 60 && props.item.COBRADO <= 100
                                }"
                            >{{ props.item.COBRADO | moneda}}%
                            </td>
                            <td class="text-xs-center">{{ props.item.E1_BAIXA | fecha }}</td>
                            <td class="text-xs-center">{{ props.item.E1_PARCELA }}</td>
                            <td class="text-xs-center">{{ props.item.E1_STATUS }}</td>
                            <td class="text-xs-center">
                                <v-menu bottom left>
                                    <v-btn slot="activator" icon small>
                                        <v-icon>more_vert</v-icon>
                                    </v-btn>
                                    <v-list>
                                        <v-list-tile @click="obsShow(props.item)">
                                            <v-list-tile-avatar>
                                                <v-icon>fa-comment</v-icon>
                                            </v-list-tile-avatar>
                                            <v-list-tile-title>Mostrar observaciones</v-list-tile-title>
                                        </v-list-tile>
                                        <v-list-tile @click="obsAdd(props.item)">
                                            <v-list-tile-avatar>
                                                <v-icon>add</v-icon>
                                            </v-list-tile-avatar>
                                            <v-list-tile-title>Agregar observación</v-list-tile-title>
                                        </v-list-tile>
                                    </v-list>
                                </v-menu>
                            </td>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
        <!--////////////////////////////////////////////// FILTRO BÚSQUEDA //////////////////////////////////////////////-->
        <v-dialog v-model="searchFilterModal" max-width="500" scrollable>
            <v-card>
                <v-card-title class="headline grey white--text" primary-title>
                    Seleccione columnas de búsqueda
                </v-card-title>
                <v-card-text>
                    <v-list>
                        <template v-for="h in headers">
                            <v-list-tile @click="">
                                <v-list-tile-action>
                                    <v-checkbox v-model="searchFilter" :value="h.value"></v-checkbox>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                    <v-list-tile-title>{{ h.text }}</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </template>
                    </v-list>
                </v-card-text>
                <v-card-actions class="text--white">
                    <v-btn dark color="green" @click.native="searchFilterTodos">Todos</v-btn>
                    <v-btn dark color="blue" @click.native="searchFilterNinguno">Ninguno</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click.native="searchFilterModal = false; consulta()">aplicar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--////////////////////////////////////////////// FILTRO //////////////////////////////////////////////-->
        <v-dialog v-model="filterModal" max-width="800" scrollable>
            <v-card>
                <v-card-title class="headline grey white--text" primary-title> Filtro</v-card-title>
                <v-card-text>
                    <v-container>
                        <v-layout>
                            <v-flex>
                                <v-menu
                                        ref="menuDesdeFE"
                                        :close-on-content-click="false"
                                        v-model="menuDesdeFE"
                                        :nudge-right="40"
                                        :return-value.sync="filter.desdeFE"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        min-width="290px"
                                >
                                    <v-text-field
                                            slot="activator"
                                            v-model="filter.desdeFE"
                                            label="Desde fecha de emision"
                                            prepend-icon="event"
                                            readonly
                                            clearable
                                    ></v-text-field>
                                    <v-date-picker v-model="filter.desdeFE" no-title scrollable locale="es-sp">
                                        <v-spacer></v-spacer>
                                        <v-btn flat color="primary" @click="menuDesdeFE = false">Cancel</v-btn>
                                        <v-btn flat color="primary" @click="$refs.menuDesdeFE.save(filter.desdeFE)">OK</v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex>
                                <v-menu
                                        ref="menuHastaFE"
                                        :close-on-content-click="false"
                                        v-model="menuHastaFE"
                                        :nudge-right="40"
                                        :return-value.sync="filter.hastaFE"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        min-width="290px"
                                >
                                    <v-text-field
                                            slot="activator"
                                            v-model="filter.hastaFE"
                                            label="Hasta fecha de emision"
                                            prepend-icon="event"
                                            readonly
                                            clearable
                                    ></v-text-field>
                                    <v-date-picker v-model="filter.hastaFE" no-title scrollable locale="es-sp">
                                        <v-spacer></v-spacer>
                                        <v-btn flat color="primary" @click="menuHastaFE = false">Cancel</v-btn>
                                        <v-btn flat color="primary" @click="$refs.menuHastaFE.save(filter.hastaFE)">OK</v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex>
                                <v-select v-model="filter.vendedor"
                                          label="Seleccione vendedor"
                                          :items="vendedores"
                                          item-text="A3_NOME"
                                          item-value="A3_COD"
                                          clearable
                                ></v-select>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex>
                                <cliente-select
                                        label="Seleccione cliente"
                                        v-model="filter.cliente"
                                        :empresa="empresa_id"
                                ></cliente-select>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat color="error" @click="filterModal = false">CANCELAR</v-btn>
                    <v-btn flat color="success" @click="filterModal = false; consulta()">APLICAR</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--////////////////////////////////////////////// OBSERVACIONES //////////////////////////////////////////////-->
        <v-dialog v-model="obsModal" scrollable>
            <v-card>
                <v-toolbar dark color="grey">
                    <v-btn icon dark @click.native="obsModal = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title class="headline grey white--text">Observaciones</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-container fluid>
                        <v-layout>
                            <v-flex>
                                <template v-for="o in observaciones">
                                    <div>
                                        <h3>Observación generada por {{ (o.user)?o.user.name:'' }} el {{ o.created_at }}</h3>
                                        <br>
                                        <h4>Forma de pago</h4>
                                        <p>Fecha estimada:
                                            <v-chip>{{ o.cuando }}</v-chip>
                                            en un
                                            <v-chip>{{ o.porcent }}%</v-chip>
                                        </p>
                                        <p v-if="o.pagos.length > 0">Pagando de la siguiente manera:
                                            <template v-for="f in o.pagos">
                                                <v-chip>{{ f.forma_pago.desig}} {{ f.porcent }}% {{ (f.fecha)? ' al ' + f.fecha : '' }}</v-chip>
                                            </template>
                                        </p>
                                        <v-textarea label="Observaciones" readonly flat full-width hide-details :value="o.obs" rows="1"></v-textarea>
                                    </div>
                                    <v-divider></v-divider>
                                </template>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!--////////////////////////////////////////////// AGREGA OBSERVACIONES //////////////////////////////////////////////-->
        <v-dialog v-model="obsAddModal" scrollable>
            <v-card>
                <v-toolbar dark color="grey">
                    <v-btn icon dark @click.native="obsAddModal = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title class="headline grey white--text">Agregar observaciones</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-container fluid grid-list-md>
                        <v-layout>
                            <v-flex>
                                <v-menu
                                        ref="cuando"
                                        :close-on-content-click="false"
                                        v-model="modalCuando"
                                        :nudge-right="40"
                                        :return-value.sync="observacion.cuando"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        min-width="290px"
                                >
                                    <v-text-field
                                            slot="activator"
                                            v-model="observacion.cuando"
                                            label="Fecha estimada de pago"
                                            prepend-icon="event"
                                            readonly
                                            clearable
                                    ></v-text-field>
                                    <v-date-picker v-model="observacion.cuando" no-title scrollable locale="es-sp">
                                        <v-spacer></v-spacer>
                                        <v-btn flat color="primary" @click="modalCuando = false">Cancel</v-btn>
                                        <v-btn flat color="primary" @click="$refs.cuando.save(observacion.cuando)">OK</v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex>
                                <v-text-field readonly label="Saldo total" :value="observacion.saldo | moneda(1)"></v-text-field>
                            </v-flex>
                            <v-flex>
                                <v-text-field label="Porcentaje sobre total" v-model="observacion.porcent"></v-text-field>
                            </v-flex>
                            <v-flex>
                                <v-text-field readonly label="Equivalente" :value="equivalenteTotal | moneda(1)"></v-text-field>
                            </v-flex>
                        </v-layout>
                        <h3>¿Cómo abona el monto de {{ equivalenteTotal | moneda(1) }}?</h3>
                        <v-layout>
                            <v-flex>
                                <v-select
                                        return-object
                                        item-value="id"
                                        item-text="desig"
                                        label="Forma de pago"
                                        :items="formas_pago"
                                        v-model="forma.forma_pago"></v-select>
                            </v-flex>
                            <v-flex v-if="forma.forma_pago.selector_fecha">
                                <v-menu
                                        ref="fechaPago"
                                        :close-on-content-click="false"
                                        v-model="modalfechaPago"
                                        :nudge-right="40"
                                        :return-value.sync="forma.fecha"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        min-width="290px"
                                >
                                    <v-text-field
                                            slot="activator"
                                            v-model="forma.fecha"
                                            label="Fecha del documento"
                                            prepend-icon="event"
                                            readonly
                                            clearable
                                    ></v-text-field>
                                    <v-date-picker v-model="forma.fecha" no-title scrollable locale="es-sp">
                                        <v-spacer></v-spacer>
                                        <v-btn flat color="primary" @click="modalfechaPago = false">Cancel</v-btn>
                                        <v-btn flat color="primary" @click="$refs.fechaPago.save(forma.fecha)">OK</v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex>
                                <v-text-field label="Porcentaje" v-model="forma.porcent"></v-text-field>
                            </v-flex>
                            <v-flex>
                                <v-text-field label="Equivalente" :value="equivalenteSaldo | moneda(1)"></v-text-field>
                            </v-flex>
                            <v-flex>
                                <v-btn flat icon color="success" @click.native="pagoAdd()">
                                    <v-icon>add</v-icon>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex>
                                <template v-for="(f,index) in observacion.formas">
                                    <v-chip close @input="pagoDel(index)">{{ f.forma_pago.desig}} {{ f.porcent }}% {{ (f.fecha)? ' al ' + f.fecha : '' }}</v-chip>
                                </template>
                                <span>Saldo: {{ pagoSaldo | moneda(1) }}</span>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex>
                                <v-textarea label="Observación" v-model="observacion.obs"></v-textarea>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat color="error" @click="obsAddModal = false">CANCELAR</v-btn>
                    <v-btn flat color="success" @click="obsAddModal = false; obsStore()">GUARDAR</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import {mapActions} from 'vuex';
    import clienteSelect from '../../components/MicroClienteSelect';
    import empresaSelect from '../../components/EmpresaSelect.vue';
    import filterMoneda from '../../filters/moneda';
    import filterDecimales from '../../filters/decimales';
    import filterFecha from '../../filters/fecha-micro';
    import mixinVendedores from '../../mixins/micro/vendedores';
    import mixinFormaPago from '../../mixins/forma_pago';

    export default {
        name: "cobranzas",
        components: {empresaSelect, clienteSelect},
        filters: {moneda: filterMoneda, decimales: filterDecimales, fecha: filterFecha},
        mixins: [mixinVendedores, mixinFormaPago],
        data() {
            return {
                search: '',
                loading: false,
                searchFilterModal: false,
                searchFilter: [],
                filterModal: false,
                filter: {
                    desdeFE: '',
                    hastaFE: '',
                    vendedor: '',
                    cliente: ''
                },
                menuDesdeFE: false,
                menuHastaFE: false,
                headers: [
                    {text: 'Estado', value: '', align: 'center', sortable: false},
                    {text: 'F. emision', value: 'F2_EMISSAO', align: 'center'},
                    {text: 'Especie', value: 'X5_DESCSPA', align: 'center'},
                    {text: 'Serie', value: 'F2_SERIE', align: 'center'},
                    {text: 'Documento', value: 'F2_DOC', align: 'center'},
                    {text: 'Cliente', value: 'A1_NOME', align: 'center'},
                    {text: 'CUIT', value: 'A1_CGC', align: 'center'},
                    {text: 'Presup', value: 'F2_USREQVE', align: 'center'},
                    {text: 'Vendedor', value: 'A3_NOME', align: 'center'},
                    {text: 'Importe S/IVA', value: 'F2_VALMERC', align: 'center'},
                    {text: 'Importe', value: 'F2_VALFAT', align: 'center'},
                    {text: 'Saldo', value: 'E1_SALDO', align: 'center'},
                    {text: '%Cobrado', value: '', align: 'center'},
                    {text: 'F. baja', value: 'E1_BAIXA', align: 'center'},
                    {text: 'Cuota', value: 'E1_PARCELA', align: 'center'},
                    {text: 'Estado', value: 'E1_STATUS', align: 'center'},
                ],
                items: [],
                soloSaldo: this.$ls.get('soloSaldo'),
                empresa_id: '',
                totalItems: 0,
                pag: {},
                rows: [10, 20, 30, {text: 'Todo', value: -1}],
                vendedores: [],
                obsModal: false,
                obsAddModal: false,
                observaciones: [],
                observacion: {
                    doc_id: '',
                    obs: '',
                    cuando: '',
                    porcent: '',
                    formas: [],
                    saldo: 0,
                    total: 0
                },
                forma: {
                    fecha: '',
                    porcent: 0,
                    monto: 0,
                    forma_pago: {}
                },
                modalCuando: false,
                modalfechaPago: false,
                formas_pago: []
            }
        },
        computed: {
            equivalenteTotal() {
                return (this.observacion.porcent * this.observacion.saldo) / 100;
            },
            equivalenteSaldo() {
                return (this.forma.porcent * this.equivalenteTotal) / 100;
            },
            pagoSaldo() {
                let total = this.observacion.formas.reduce((valorAnterior, valorActual) => {
                    return valorAnterior + valorActual.monto;
                }, 0);
                return this.equivalenteTotal - total;
            }
        },
        watch: {
            pag: {
                handler() {
                    this.consulta();
                },
                deep: true
            }
        },
        mounted() {
            this.vendedoresList(r => {
                this.vendedores = r;
            }, err => {
                console.log('erro al obtener listado de vendedores');
            });
            this.formaPagoSelect(r => {
                this.formas_pago = r;
            }, err => {
                console.log('error al traer formas de pago')
            })
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            guardaPref(campo, valor) {
                this.$ls.set(campo, valor)
                this.msjShow({txt: 'Preferencia guardada', tipo: 'ok'});
            },
            searchFilterTodos() {
                this.headers.forEach(r => {
                    this.searchFilter.push(r.value)
                })
            },
            searchFilterNinguno() {
                this.searchFilter = [];
            },
            consulta() {
                if (!this.empresa_id) {
                    return false;
                }
                this.loading = true;
                this.pag.search = this.search;
                this.$http.post('informes/cobranzas/consulta?page=' + this.pag.page, {
                    emp: this.empresa_id,
                    soloSaldo: this.soloSaldo,
                    params: this.pag,
                    searchFilter: this.searchFilter,
                    filter: this.filter
                })
                    .then(r => {

                        this.items = r.data.data;
                        this.totalItems = r.data.total;
                        this.loading = false;
                    })
                    .catch(err => {
                        console.log(err);
                        this.loading = false;
                    })
            },
            obsShow(item) {
                this.observaciones = item.OBS;
                this.obsModal = true;
            },
            obsAdd(item) {
                this.obsAddModal = true;
                this.observacion.doc_id = item.F2_DOC;
                this.observacion.saldo = item.E1_SALDO;
            },
            obsStore() {
                this.loading = true;
                this.$http.post('informes/cobranzas/obs-store', this.observacion)
                    .then(r => {
                        this.msjShow(r.data);
                        this.consulta();
                        this.loading = false;
                    })
                    .catch(err => {
                        this.msjShow({txt: 'Error al guardar observación', tipo: 'error'});
                        this.loading = false;
                    })
            },
            pagoAdd() {
                this.forma.monto = this.equivalenteSaldo;
                let item = {};
                Object.assign(item, this.forma);
                this.observacion.formas.push(item)
                this.forma = {
                    fecha: '',
                    porcent: 0,
                    monto: 0,
                    forma_pago: {}
                }
            },
            pagoDel(index) {
                this.observacion.formas.splice(index, 1);
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/informes/cobranzas.vue